import React from "react";
import { formatWrittenDayMonthYear } from "utilities";

interface Props {
  className?: string
  startDate: moment.Moment
  endDate: moment.Moment
}

export const ProductionDateRange = (props: Props) => {
  const { className, startDate, endDate } = props;

  const hasDates = startDate != null;
  let isLongerThanOneDay = false;
  if (hasDates) {
    isLongerThanOneDay = endDate.diff(startDate, "days") > 1;
  }

  if (!hasDates) {
    return null;
  }

  return <div className={className}>
    {formatWrittenDayMonthYear(startDate)}
    {isLongerThanOneDay && ` ${RESX.DateTime.UntilAndIncludingAbbreviated} ${formatWrittenDayMonthYear(endDate)}`}
  </div>;
}